export default __webpack_public_path__ + "static/media/algodao_v5_a_v18_ou_b1_a_b7.7241eb7c.png";